import { Component, OnDestroy } from "@angular/core";
import { Toast, ToastrService } from "./toastr.service";
import { Subscription } from "rxjs";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  selector: "app-toastr",
  templateUrl: "./toastr.component.html",
  styleUrls: ["./toastr.component.scss"],
  standalone: false,
})
export class ToastrComponent implements OnDestroy {
  toasts: Toast[] = [];
  private subscription: Subscription;
  isMobile = false;

  constructor(
    private _toastrService: ToastrService,
    private _bo: BreakpointObserver
  ) {
    this.subscription = this._toastrService.toastsSubject.subscribe(
      (toasts) => {
        this.toasts = toasts;
      }
    );

    // Observer les changements de breakpoint pour le responsive
    this._bo.observe([Breakpoints.HandsetPortrait]).subscribe((result) => {
      this.isMobile = result.matches;
      // Informer le service de l'état mobile
      this._toastrService.setMobileState(this.isMobile);
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onToastClose(id: number) {
    this._toastrService.remove(id);
  }

  trackByFn(index: number, toast: Toast): number {
    return toast.id;
  }
}
